"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveFirstByIndex = void 0;
const ramda_1 = require("ramda");
/**
 * Moves as the first element of the items the element of the index indicated
 *
 * @param items - Array of elements
 * @param index - number, indicates the new position of the first element of the array
 * @returns The new array with the new order
 *
 * @public
 
 * @example
 * ```ts
 * cont result = moveFirstByIndex([5,1,2,3,4], 4)
 * console.log(result);
 *
 * // -> [4, 5, 1, 2, 3]
 * ```
 */
function moveFirstByIndex(items, index) {
    return (0, ramda_1.when)((0, ramda_1.always)((0, ramda_1.gte)(index, 0)), (0, ramda_1.move)(index, 0), items);
}
exports.moveFirstByIndex = moveFirstByIndex;
//# sourceMappingURL=move-first-by-index.js.map